import { cn } from '../../lib/utils'
import type { Status } from './types'

export interface BarProps {
  value: number
  max?: number
  status?: Status
  className?: string
  ariaLabel?: string
}

const FILL: Record<Status, string> = {
  run: 'bg-st-run',
  warn: 'bg-st-warn',
  down: 'bg-st-down',
  idle: 'bg-ink',
  info: 'bg-st-info'
}

export function Bar({ value, max = 100, status, className, ariaLabel }: BarProps) {
  const pct = Math.max(0, Math.min(1, value / max))
  return (
    <div
      role="progressbar"
      aria-label={ariaLabel}
      aria-valuemin={0}
      aria-valuemax={max}
      aria-valuenow={Math.max(0, Math.min(max, value))}
      data-st={status}
      className={cn('h-1.5 overflow-hidden rounded-full bg-bg-sunk', className)}
    >
      <span
        className={cn('block h-full rounded-full transition-[width]', FILL[status ?? 'idle'])}
        style={{ width: `${pct * 100}%` }}
      />
    </div>
  )
}
